import React from "react";
import BuyerInfo from "./BuyerInfo";
import CRUD from "../CRUD/CRUD";
import {browserHistory} from "react-router";
import {formatName, formatType, capitalizeAll, addSpaceAfterComma} from "../../utils";
import {dateISOtoUS, dateUStoISO} from "../../date-converter";
import {getData, manageData} from "../../requests/CRUD";
import {BUYERS} from "../../consts/tables";
import {send1031BuyerEmail} from "../../requests/emailRequests";
import BuyerCompanyInfo from "./BuyerCompanyInfo";
import {priceToString} from "../CRUDProperty/CRUDProperty";

const priceProps = [
    "PRICE_MIN",
    "PRICE_MAX",
];

const dateProps = [
    "LAST_MODIFIED"
];

function convertDataToForm(dbData) {
    const data = {...dbData};

    priceProps
        .filter((key) => data[key])
        .forEach((key) => {
            const num = Number(data[key]);
            if (num === num) {
                // !isNaN
                data[key] = num.toLocaleString();
            }
        });

    dateProps
        .filter(key => data[key])
        .forEach(key => {
            const str = dateISOtoUS(data[key]);
            if (str !== false)
                data[key] = str;
        });

    return data;
}

function convertFormToData(formData) {
    const data = {...formData};

    priceProps.forEach((key) => {
        const num = priceToString(data[key]);
        if (num !== false)
            data[key] = num;
    });

    dateProps
        .filter(key => data[key])
        .forEach(key => {
            const str = dateUStoISO(data[key]);
            if (str !== false)
                data[key] = str;
        });

    return data;
}

export default class CRUDBuyer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            original: null,
            isBusy: null,
            error: null,
            success: null,
            errorTabs: [],
            currentTab: 0,
            viewMode: this.props.edit || false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.id !== nextProps.params.id) {
            this.fetch(nextProps.params.id);
        }
    }

    componentDidMount() {
        this.fetch(this.props.params.id);
    }

    fetch(id) {
        this.setState({
            data: null,
            error: null,
            success: null,
        });

        if (id === undefined) {
            this.setState({data: {}});
            return;
        }

        getData({
            tableCode: BUYERS,
            options: {
                filter: [{
                    text: id,
                    code: "ARCIMEDES_ROW_ID",
                    type: "exact",
                }],
            },
        }).then(res => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                this.setState({
                    data: convertDataToForm(res.data[0]),
                    original: {...convertDataToForm(res.data[0])},
                    error: null,
                });
            } else {
                this.setState({
                    data: false,
                    error: res.message ? res.message : "Unidentified Error",
                });
            }
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        if (this.state.viewMode) this.setState({viewMode: false});

        if (this.state.data.FIRST_NAME === undefined || this.state.data.FIRST_NAME === "" ||
            this.state.data.LAST_NAME === undefined || this.state.data.LAST_NAME === "") {
            this.setState({errorTabs: [0], success: null});
            return;
        } else {
            this.setState({errorTabs: []});
        }

        if (this.state.isBusy || this.state.viewMode === true) return;

        this.setState({viewMode: true}, () => this.saveData());
    }

    handleChangeInput(key, value) {
        this.setState({
            data: Object.assign(this.state.data, {[key]: value}),
        });
    }

    handleChangeDropdown(query, queryType, x, key) {
        const data = {...this.state.data};
        if (key === 'STATUS') {
            data.LAST_MODIFIED = new Date().toLocaleDateString("en-US");
            if (!query[key]) {
                data.CATEGORY = null;
                data.TYPE = null;
                data.SINGLE_TENANT_SUBCATEGORY = null;
                data.MULTI_TENANT_SUBCATEGORY = null;
                data.MARKET = null;
                data.PRICE_MIN = null;
                data.PRICE_MAX = null;
                data.CAP_RATE_MIN = null;
                data.CAP_RATE_MAX = null;
                data.STRIVE_AGENT = null;
            }
        }
        data[key] = query[key];
        this.setState({data});
    }

    saveData() {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });

        Object.keys(this.state.data).forEach((k) => {
            if (!this.state.data[k] || k === "undefined") {
                const newData = {...this.state.data};
                delete newData[k];
                this.setState({data: newData});
            }
        });

        Promise.all([
            manageData({
                tableCode: BUYERS,
                data: [convertFormToData(this.state.data)],
            }),
            getData({
                tableCode: "TEAM",
                options: {
                    column: ["FIRST_NAME", "LAST_NAME"],
                    filter: [{
                        text: this.state.data.STRIVE_AGENT ? this.state.data.STRIVE_AGENT : "",
                        code: "ARCIMEDES_ROW_ID",
                        type: "exact",
                    }],
                },
            }),
        ]).then((res) => {
            if (res && res[0] && res[0].success && res[1] && res[1].success) {
                this.setState({
                    isBusy: false,
                    success: "Saved",
                }, () => {
                    if (!this.props.edit) {
                        browserHistory.push({
                            pathname: `/buyer/${res[0].data[0].ARCIMEDES_ROW_ID}`,
                        });
                    }}
                );
                window.scrollTo(0, 0);
            } else {
                this.setState({
                    isBusy: null,
                    error: res && res[0] && res[0].message ? res[0].message : "Unspecified error",
                });
            }
            return {
                success: res[0].success && res[1].success,
                CATEGORY: capitalizeAll(res[0].data[0].CATEGORY),
                TYPE: formatType(res[0].data[0].TYPE),
                MARKET: capitalizeAll(res[0].data[0].MARKET),
                TENANT_SUBCATEGORY: res[0].data[0].TYPE === "MT" ? addSpaceAfterComma(res[0].data[0].MULTI_TENANT_SUBCATEGORY) : res[0].data[0].TYPE === "STNL" ? addSpaceAfterComma(res[0].data[0].SINGLE_TENANT_SUBCATEGORY) : null,
                PRICE_MIN: res[0].data[0].PRICE_MIN,
                PRICE_MAX: res[0].data[0].PRICE_MAX,
                CAP_RATE_MIN: res[0].data[0].CAP_RATE_MIN,
                CAP_RATE_MAX: res[0].data[0].CAP_RATE_MAX,
                STRIVE_AGENT: res[1].data.length ? formatName(res[1].data[0]) : null,
            };
        }).then((res) => {
            if (res.success)
                send1031BuyerEmail(res);
        });
    }

    render() {
        const data = this.state.data;
        const {edit} = this.props;

        return (
            <CRUD
                tabsData={[
                    {
                        name: "Buyer",
                        renderedComponent: (
                            <BuyerInfo
                                data={data}
                                handleChangeInput={this.handleChangeInput}
                                handleChangeDropdown={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                deleted={data && data.DELETED === "1"}
                            />
                        ),
                    },
                    {
                        name: "Buyer Company",
                        renderedComponent: (
                            <BuyerCompanyInfo
                                data={data}
                                handleChangeInput={this.handleChangeInput}
                                handleChangeDropdown={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                deleted={data && data.DELETED === "1"}
                            />
                        ),
                    },
                ]}
                backLink={`${arc.path.base}buyers`}
                edit={edit}
                state={this.state}
                setState={this.setState.bind(this)}
                handleSubmit={this.handleSubmit}
                saveData={this.saveData}
                type="buyer"
                backName="BUYERS"
                title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
            />
        );
    }
}
